import { createFileRoute } from '@tanstack/react-router';
import { PointQrPage } from '../pages/point-qr';

export const Route = createFileRoute('/p/$pointId')({
  component: PointQrRoute,
});

function PointQrRoute() {
  const { pointId } = Route.useParams();
  return <PointQrPage pointId={pointId} />;
}
